module.exports = __webpack_public_path__ + "static/media/DyerArtsandCrafts.c9ee159b.ttf";